var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPaymentLogoZip = function SvgIconPaymentLogoZip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "icon-payment-logo-zip_svg__\\u56FE\\u5C42_1",
    x: 0,
    y: 0,
    viewBox: "0 0 448 256"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".icon-payment-logo-zip_svg__st2{fill:#1a0826}")), /*#__PURE__*/React.createElement("path", {
    d: "m163 100.3 12.2 99.2h119.2l-12.2-99.2z",
    style: {
      fill: "#aa8fff"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M197 62.4c7.6 7.2 8.7 18.4 2.3 25.1-6.3 6.7-17.6 6.4-25.2-.8s-8.7-18.4-2.3-25.1c6.3-6.7 17.6-6.3 25.2.8",
    className: "icon-payment-logo-zip_svg__st2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M419.4 136c-2.7-22.3-20.3-35.8-44.1-35.7H296l12.2 99.2h35.7l-2.4-19.8h37.7c29.7-.1 43.3-18.6 40.2-43.7m-44.1 15.8H338l-2.9-23.8h37.5c8.8.1 13.3 5.1 14.1 11.9.4 4.4-1.6 11.9-11.4 11.9",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#1a0826"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m38.9 171.7 3.4 27.7h119.1l-3.9-31.7H102l-.5-3.9 51.1-35.7-3.4-27.8H30.1L34 132h55.6l.5 4z",
    className: "icon-payment-logo-zip_svg__st2"
  })));
};
export default SvgIconPaymentLogoZip;